__turbopack_context__.v({
  "className": "helveticaneue_82fe5bdd-module__2gnzPa__className",
  "variable": "helveticaneue_82fe5bdd-module__2gnzPa__variable",
});
